import { spawn } from 'redux-saga/effects';
import { sagas as lookup } from './lookupModule';

export default function* sagas() {
	yield spawn(lookup);
}
